export default __webpack_public_path__ + "static/media/Nueva_solicitud.c68aa8f9.svg";